export default function disposeErrors(errorsVar) {
    return function () {
        errorsVar(null);
    };
}
